import { TableBody } from '@cobliteam/ui/components/Table';
import type { ColumnDef, Table as ITable, Row } from '@tanstack/react-table';
import type { VirtualItem } from '@tanstack/react-virtual';
import DataTableEmptyState from './DataTableEmptyState';
import DataTableRow from './DataTableRow';

interface DataTableBodyProps<TData, TValue> {
  selectedActions?: (table: ITable<TData>, columnsDef: any) => React.ReactNode;
  isVirtualized: boolean;
  rows: Row<TData>[];
  virtualizer: any;
  virtualItems?: VirtualItem[];
  isLoading: boolean;
  isFetching: boolean;
  columnsDef: ColumnDef<TData, TValue>[];
  data: TData[];
  table: ITable<TData>;
  emptyStatePlaceholder?: React.ReactNode;
}

const DataTableBody = <TData, TValue>({
  selectedActions: SelectedActions,
  isVirtualized,
  rows,
  virtualizer,
  isLoading,
  isFetching,
  columnsDef,
  data,
  table,
  emptyStatePlaceholder,
}: DataTableBodyProps<TData, TValue>) => {
  return (
    <TableBody>
      {/* // SELECTED ACTIONS COMPONENTS  */}
      {SelectedActions && data ? SelectedActions(table, columnsDef) : null}

      {/* //  VIRTUALIZED */}
      {isVirtualized
        ? virtualizer.getVirtualItems().map((virtualRow: VirtualItem) => {
            const row = rows[virtualRow.index];

            const selected = row.getIsSelected();
            return <DataTableRow virtualizer={virtualizer} key={virtualRow.key} index={virtualRow.index} row={row as Row<unknown>} selected={selected} />;
          })
        : rows.map((row, index) => {
            const selected = row.getIsSelected();
            return <DataTableRow key={row.id} index={index} row={row as Row<unknown>} selected={selected} />;
          })}

      {/* // EMPTY STATE */}
      <DataTableEmptyState rows={rows} isLoading={isLoading} isFetching={isFetching} columnsDef={columnsDef} placeholder={emptyStatePlaceholder} />
    </TableBody>
  );
};

export default DataTableBody;
